import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { BiLoaderAlt } from "react-icons/bi";

import { SERVERURL } from "../../ServerUrl";

const HEADING = "Our Newsletter";
const SUBCOPY =
  "Join our weekly newsletter to stay updated on the latest news & analysis sent to your mailbox.";
const CONSENT = "By joining, I agree to TCH Terms & Privacy statements";

const NewsLetter = () => {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(0);
  const [isChecked, setIsChecked] = useState(false);

  const subscribeClicked = async () => {
    if (email && isChecked) {
      const data = { email: email };

      setLoader(1);

      try {
        const response = await axios.post(`${SERVERURL}/api/v1/subscribe`, data);

        setLoader(0);

        if (response.data.success === true) {
          Swal.fire(response?.data?.message, response.data.status, "success");
          setEmail("");
          setIsChecked(false);
        } else {
          Swal.fire(response?.data?.message, response.data.status, "warning");
          setEmail("");
        }
      } catch (error) {
        console.error("Error:", error);
        setLoader(0);
        Swal.fire("Error", "An error occurred while subscribing", "error");
      }
    } else {
      Swal.fire(
        "Empty Field",
        email
          ? "Please agree to the Terms and Privacy statements"
          : "Please Enter Email",
        "warning"
      );
    }
  };

  return (
    <section
      id="newsletter"
      className="w-full relative overflow-hidden bg-[#010810] py-12 md:py-16"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-stretch">
        {/* Heading sits on the input's top edge; the copy follows it directly
            rather than stretching to the button's bottom edge. */}
        <div>
          {/* Manrope leaves dead space above its cap line at this line-height;
              pulling it back up puts the cap line — not the line box — on the
              same top edge as the email input beside it. In `em` so it tracks
              the clamped font size, and `!` because Bootstrap's `.m-0` /
              `.mb-0` are `!important` and would otherwise win. */}
          <h2 className="font-headline font-bold tracking-tight text-white text-[clamp(2rem,4vw,3rem)] leading-[1.12] mb-0 md:!-mt-[0.22em]">
            {HEADING}
          </h2>
          <p className="font-headline text-on-surface-variant text-lg md:text-xl leading-relaxed max-w-md mt-2 mb-0">
            {SUBCOPY}
          </p>
        </div>

        <div className="flex flex-col !flex-nowrap gap-4">
          <input
            type="email"
            placeholder="Type your email address"
            aria-label="Email address"
            className="w-full bg-white/[0.04] border border-outline-variant/30 rounded-md px-4 py-3.5 font-body text-on-surface placeholder:text-on-surface-variant/50 focus:outline-none focus:border-accent/60 transition-colors duration-300"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />

          <label
            htmlFor="termsCheckbox"
            className="flex !flex-nowrap !justify-start items-start gap-2.5 cursor-pointer font-body text-[13px] leading-snug text-on-surface-variant m-0"
          >
            <input
              type="checkbox"
              id="termsCheckbox"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              className="mt-0.5 w-4 h-4 shrink-0 accent-accent cursor-pointer"
            />
            {CONSENT}
          </label>

          <button
            type="button"
            onClick={subscribeClicked}
            disabled={loader === 1}
            className="group w-full bg-accent !border-0 px-8 py-3.5 rounded-md font-headline font-bold !text-accent-ink hover:bg-accent-hover transition-all duration-300 active:scale-95 flex items-center !justify-center gap-2 disabled:opacity-70"
          >
            {loader === 1 ? (
              <BiLoaderAlt className="animate-spin w-5 h-5" />
            ) : (
              <>
                <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">
                  Subscribe
                </span>
                <span className="material-symbols-outlined text-[18px] group-hover:animate-arrow-slide">
                  arrow_forward
                </span>
              </>
            )}
          </button>
        </div>
      </div>
    </section>
  );
};

export default NewsLetter;
